import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-mask" }
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "d-flex justify-content-end gap-2" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalBase',
  props: [
  'title',
  'closeText',
  'showOtherButton',
  'otherButtonText',
],
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_b_card_title = _resolveComponent("b-card-title")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_card, { class: "modal-container" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_card_body, null, {
            default: _withCtx(() => [
              _createVNode(_component_b_card_title, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.title), 1)
                ]),
                _: 1
              }),
              _renderSlot(_ctx.$slots, "content"),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_b_button, {
                  variant: "outline-primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.closeText), 1)
                  ]),
                  _: 1
                }),
                (__props.showOtherButton)
                  ? (_openBlock(), _createBlock(_component_b_button, {
                      key: 0,
                      variant: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('action')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.otherButtonText), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ])
  ]))
}
}

})